import { AAccentLineSize } from '../../atoms/AAccentLine';
import { MBrandElementType, MBrandElementProps } from '../../molecules/MBrandElement/MBrandElement.types';

export enum OBannerTextContentAlignment {
  Center = 'Centered',
  Left = 'Left',
}

export interface OBannerTextButton {
  buttonText?: string | null;
  type?: string | null;
  ctaLink?: string | null;
  openInANewTab?: string | null;
}

export interface OBannerTextParagraph {
  truncated?: string | null;
  expanded?: string | null;
  aBody?: {
    bodyText?: string | null;
  };
}

export interface OBannerTextBrandElement {
  type?: MBrandElementType;
  mLogoContainer?: {
    aLogo32?: {
      brand?: string | null;
    };
  };
  aIcon?: {
    icon?: string | null;
    size?: string | null;
  };
  aImage?: {
    image: MBrandElementProps['image'];
  };
}

export interface OBannerTextLogoBrandElement extends OBannerTextBrandElement {
  type: MBrandElementType.Logo;
  mLogoContainer: {
    aLogo32: {
      brand: string;
    };
  };
  aIcon: never;
  aImage: never;
}

export interface OBannerTextIconBrandElement extends OBannerTextBrandElement {
  type: MBrandElementType.Icon;
  mLogoContainer: never;
  aIcon: {
    icon: string;
    size?: string;
  };
  aImage: never;
}

export interface OBannerTextImageBrandElement extends OBannerTextBrandElement {
  type: MBrandElementType.Image;
  mLogoContainer: never;
  aIcon: never;
  aImage: {
    image: MBrandElementProps['image'];
  };
}

export interface OBannerTextBlockStandard {
  aEyebrow?: {
    eyebrowText?: string | null;
  };
  aHeader?: {
    text?: string | null;
    size?: string | null;
    headerTag?: string | null;
  };
}

// defined separately because these props are derived from styleclass
export interface OBannerTextAccentLine {
  show: boolean;
  size: AAccentLineSize;
}

export interface OBannerTextProps {
  alignment?: OBannerTextContentAlignment;
  mBrandElement?: OBannerTextBrandElement;
  mTextBlockStandard?: OBannerTextBlockStandard;
  mParagraph?: OBannerTextParagraph;
  mParagraph2?: OBannerTextParagraph;
  dividerOrientation?: string;
  mButton2?: OBannerTextButton;
  mButton?: OBannerTextButton;
  aAccentLine?: OBannerTextAccentLine;
  className?: string;
}
